module.exports = __webpack_public_path__ + "media/images/svg/dolar-b41ced4305757412e9d7a85a1d79e76a.svg";